import {
  Checkbox as MuiCheckbox,
  FormControlLabel,
  FormControlLabelProps,
} from "@mui/material";
import { forwardRef } from "react";

interface CheckboxProps extends Omit<FormControlLabelProps, "control"> {
  checkboxProps?: React.ComponentProps<typeof MuiCheckbox>;
}

const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
  const { label, checkboxProps, sx, ...rest } = props;

  return (
    <FormControlLabel
      control={<MuiCheckbox ref={ref} {...checkboxProps} />}
      label={label}
      sx={{ marginY: "0.4rem", ...sx } as any}
      {...rest}
    />
  );
});

Checkbox.displayName = "Checkbox";

export default Checkbox;
